<template>
  <div class="main-container">
    <v-toolbar
        flat
        tile
        class="box"
        style="background-color:transparent"
    >
      <v-btn icon @click="$router.go(-1)">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title class="pl-0">
        Order
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
          v-if="$store.state.authUser.user_permissions.includes('add_order')"
          depressed
          @click="$router.push({path: '/order/create'})"
          color="success"
      >เปิดออเดอร์ใหม่
      </v-btn>
      <v-btn @click="showFilter = !showFilter" icon>
        <v-icon>mdi-filter</v-icon>
      </v-btn>
    </v-toolbar>
    <!--    <div class="mx-4 box box-2" style="min-height: 100%;">-->
    <!--      <v-row dense class="box box-2" style="height: 100%;display: flex;flex-direction: row">-->
    <!--        <v-col-->
    <!--            style="height: 100%"-->
    <!--        >-->
    <div class="mr-4 box box-2" style="min-height: 100%;">
      <splitpanes style="height: 100%">
        <pane :size="showFilter ? 80 : 100" style="overflow: auto" class="pl-4 pb-4">
          <v-expansion-panels v-model="quotationPanel">
            <v-expansion-panel
            >
              <v-expansion-panel-header>
                รายการใบเสนอราคาที่ยังไม่รับออเดอร์ ({{ quotationCount }})
              </v-expansion-panel-header>
              <v-expansion-panel-content id="innerExPan" class="px-0">
                <v-data-table
                    :loading="quotationOrdersLoading"
                    loading-text="Loading... Please wait"
                    :custom-filter="customFilter"
                    :headers="headers"
                    :items="quotationOrders"
                    :options.sync="quotationTableOptions"
                    :server-items-length="quotationTotalCount"
                    :footer-props="quotationFooterProps"
                    class="elevation-1"
                    no-data-text="ไม่มีข้อมูล"
                    :header-props="{ sortIcon: null }"
                    @click:row="gotoPODetail"
                    @update:options="onQuotationTableOptions"
                    :search="search"

                >
                  <template v-slot:item.total_price="{item}">
                    <p class="text-right mb-0">{{ $currency(item.total_price).format() }}</p>
                  </template>

                  <template v-slot:item.order_item="{item}">
                    <p class="text-truncate" style="margin-bottom: 0">
                      {{ showProduct(item.order_item) }}
                    </p>
                  </template>

                  <template v-slot:item.order_status="{ item }">
                    <v-btn
                        :color="(colorStatus(item.order_status,item.isActive)).color"
                        outlined
                        raised
                        small
                        block
                    >{{ (colorStatus(item.order_status, item.isActive)).text }}
                    </v-btn>
                  </template>

                  <template v-slot:item.payment_status="{ item }">
                    <v-btn
                        :color="(colorStatus(item.payment_status,item.isActive)).color"
                        outlined
                        raised
                        small
                        block
                    >{{ (colorStatus(item.payment_status, item.isActive)).text }}
                    </v-btn>
                  </template>

                  <template v-slot:item.tags="{ item }">
                    <div class="d-flex flex-wrap" style="gap: 4px;">
                      <v-chip
                          v-for="tag in (item.tags || [])"
                          :key="tag.id"
                          :color="tag.color"
                          text-color="white"
                          x-small
                      >
                        {{ tag.name }}
                      </v-chip>
                    </div>
                  </template>

                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-card
              class="mt-4 rounded-lg elevation-2"
              outlined
              tile
          >

            <v-data-table
                :loading="$store.state.isLoading"
                loading-text="Loading... Please wait"
                :custom-filter="customFilter"
                :headers="headers"
                :items="orders"
                :options.sync="ordersTableOptions"
                :items-per-page="-1"
                hide-default-footer
                class="elevation-1"
                no-data-text="ไม่มีข้อมูล"
                :header-props="{ sortIcon: null }"
                @click:row="gotoPODetail"
                :search="search"


            >
              <template v-slot:item.total_price="{item}">
                <p class="text-right mb-0">{{ $currency(item.total_price).format() }}</p>
              </template>
              <template v-slot:item.id_display="{item}">
                {{ item.id_display }}
              </template>
              <template v-slot:item.order_item="{item}">
                <p class="text-truncate" style="margin-bottom: 0">
                  {{ showProduct(item.order_item) }}
                </p>

              </template>
              <template v-slot:item.order_status="{ item }">
                <!--                {{ item }}-->
                <v-btn
                    :color="(colorStatus(item.order_status,item.isActive)).color"
                    outlined
                    raised
                    small
                    block
                >{{ (colorStatus(item.order_status, item.isActive)).text }}
                </v-btn>
              </template>

              <template v-slot:item.payment_status="{ item }">
                <v-btn
                    :color="(colorStatus(item.payment_status,item.isActive)).color"
                    outlined
                    raised
                    small
                    block
                >{{ (colorStatus(item.payment_status, item.isActive)).text }}
                </v-btn>
              </template>
              <template v-slot:item.tags="{ item }">
                <div class="d-flex flex-wrap" style="gap: 4px;">
                  <v-chip
                    v-for="tag in item.tags"
                    :key="tag.id"
                    :color="tag.color"
                    text-color="white"
                    x-small
                  >
                    {{ tag.name }}
                  </v-chip>
                </div>
              </template>
            </v-data-table>

          </v-card>
        </pane>

        <pane :size="showFilter ? 20 : 0" class="pb-4">
          <FilterCard @search-object="loadProduct" :search-option="findHeaders"
                      date
                      tax-order
                      price-min-max
                      order-status
                      :backwards="0.7"
                      show-branch-filter
                      payment-status
                      order-tags/>
        </pane>
      </splitpanes>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DateTime from "luxon/src/datetime";

import {Splitpanes, Pane} from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import FilterCard from "@/components/FilterCard";

export default {
  name: "POList",
  components: {FilterCard, Splitpanes, Pane},
  data() {
    return {
      orders: [],
      quotationOrders: [],
      quotationPanel: undefined,
      quotationCount: 0,
      quotationTotalCount: 0,
      quotationTableOptions: {
        page: 1,
        itemsPerPage: 20,
        sortBy: ['order_date'],
        sortDesc: [true],
        multiSort: false,
        mustSort: true,
      },
      quotationPrevSortSig: null,
      ordersTableOptions: {
        page: 1,
        itemsPerPage: -1,
        sortBy: ['id'],
        sortDesc: [true],
        multiSort: false,
        mustSort: true,
      },
      quotationFooterProps: {
        'items-per-page-options': [10, 20, 50],
      },
      quotationOrdersLoading: false,
      quotationSkipOptionsFetch: false,
      lastOrderSearchParams: null,
      showFilter: true,
      headers: [
        {text: 'เลขสั่งซื้อ', value: 'id_display', width: 80, align: 'center', sortable: true},
        {text: 'สาขา', value: 'branch_name', width: 80, align: 'center', sortable: true},
        {text: 'ชื่อลูกค้า', value: 'customer_name', align: 'start', minWidth: 150, sortable: true},
        {text: 'สินค้า', value: 'order_item', sortable: false},
        {text: 'ราคา', value: 'total_price', align: 'center', sortable: true},
        {text: 'วันที่สั่ง', value: 'order_date', align: 'center', sortable: true},
        {text: 'หมายเหตุ', value: 'remark', width: 150, sortable: true},
        {text: 'เลขกำกับภาษี', value: 'tax_invoice_id', align: 'center', width: 100, sortable: false},
        {text: 'Tags', value: 'tags', align: 'center', width: 150, sortable: false},
        {text: 'สถานะ', value: 'order_status', align: 'center', width: 100, sortable: true},
        {text: 'ชำระเงิน', value: 'payment_status', align: 'center', width: 100, sortable: true},
      ],
      itemsPerPage: 0,
      footerProps: {'items-per-page-options': []},
      optionSearch: '',
      search: '',
      modal: false,
      dates: [],
      filteredPO: [],
      findHeaders: [
        {
          text: 'เลขคำสั่งซื้อ',
          value: 'display_id'
        },
        {
          text: 'ชื่อลูกค้า',
          value: 'customer_name'
        },
        {
          text: 'ที่อยู่ลูกค้า',
          value: 'customer_address'
        },
        {
          text: 'ชื่อสินค้า',
          value: 'product_name'
        },
      ]
    }
  },
  created() {
    this.fetchQuotationCount()
  },
  watch: {
    quotationPanel(val) {
      if (val === 0) {
        this.quotationPrevSortSig = null
        this.quotationSkipOptionsFetch = true
        this.$nextTick(() => {
          this.fetchQuotationPage({force: true, resetPage: true}).finally(() => {
            this.$nextTick(() => {
              this.quotationSkipOptionsFetch = false
            })
          })
        })
      }
    },
  },
  methods: {
    orderStatusIsQuotation(orderStatus) {
      if (orderStatus == null || orderStatus === '') {
        return false
      }
      return String(orderStatus).includes('ใบเสนอราคา')
    },
    /** พารามิเตอร์จาก FilterCard ที่ backend ใบเสนอราคาใช้ร่วมกับ OrderManage (ไม่รวม order_status / pagination / sort) */
    extractQuotationSharedFilters(source) {
      const out = {}
      if (!source) {
        return out
      }
      const keys = [
        'start_date', 'end_date', 'display_id', 'customer_name', 'customer_address',
        'product_name', 'payment_status', 'min_price', 'max_price', 'is_tax_invoice',
      ]
      keys.forEach((k) => {
        const v = source[k]
        if (v !== null && v !== undefined && v !== '') {
          out[k] = v
        }
      })
      if (Array.isArray(source.tag_ids) && source.tag_ids.length) {
        out.tag_ids = [...source.tag_ids]
      }
      return out
    },
    mergeQuotationListParams(baseParams) {
      const p = this.lastOrderSearchParams
      if (!p || !this.orderStatusIsQuotation(p.order_status)) {
        return baseParams
      }
      return {...baseParams, ...this.extractQuotationSharedFilters(p)}
    },
    fetchQuotationCount(params) {
      const source = params || this.lastOrderSearchParams
      const reqParams = {}
      if (source && source.branch_ids && source.branch_ids.length) {
        reqParams.branch_ids = source.branch_ids
      }
      if (source && this.orderStatusIsQuotation(source.order_status)) {
        Object.assign(reqParams, this.extractQuotationSharedFilters(source))
      }
      axios.get('/api/orders/quotation_count/', {params: reqParams})
          .then(res => {
            this.quotationCount = res.data.data.count
          })
          .catch(e => {
            this.$store.state.snackbar = {
              text: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง ข้อความที่ระบบแจ้ง : ' + e.response.status + ' ' + e.response.statusText,
              visible: true,
              color: 'error'
            }
          })
    },
    onQuotationTableOptions() {
      if (this.quotationPanel !== 0) {
        return
      }
      if (this.quotationSkipOptionsFetch) {
        return
      }
      const o = this.quotationTableOptions
      const sortSig = JSON.stringify([o.sortBy || [], o.sortDesc || []])
      if (this.quotationPrevSortSig === null) {
        this.quotationPrevSortSig = sortSig
        return
      }
      if (sortSig !== this.quotationPrevSortSig) {
        this.$set(this.quotationTableOptions, 'page', 1)
        this.quotationPrevSortSig = sortSig
      }
      this.fetchQuotationPage()
    },
    fetchQuotationPage(opts = {}) {
      const force = opts.force === true
      const resetPage = opts.resetPage === true
      if (resetPage) {
        this.$set(this.quotationTableOptions, 'page', 1)
      }
      if (this.quotationOrdersLoading && !force) {
        return Promise.resolve()
      }
      this.quotationOrdersLoading = true
      const o = this.quotationTableOptions
      const quotationSortAllow = ['id_display', 'branch_name', 'customer_name', 'total_price', 'order_date', 'remark', 'order_status', 'payment_status']
      let sortByKey = (o.sortBy && o.sortBy.length) ? o.sortBy[0] : 'order_date'
      if (!quotationSortAllow.includes(sortByKey)) {
        sortByKey = 'order_date'
      }
      const sortDescVal = (o.sortDesc && o.sortDesc.length) ? !!o.sortDesc[0] : true
      let params = {
        order_status: 'ใบเสนอราคา',
        page: o.page || 1,
        page_size: o.itemsPerPage || 20,
        sort_by: sortByKey,
        sort_desc: sortDescVal ? 1 : 0,
        is_active: 1,
      }
      if (this.lastOrderSearchParams && this.lastOrderSearchParams.branch_ids && this.lastOrderSearchParams.branch_ids.length) {
        params.branch_ids = this.lastOrderSearchParams.branch_ids
      }
      params = this.mergeQuotationListParams(params)
      return axios.get('/api/orders/', {params})
          .then(res => {
            this.quotationOrders = (res.data.data || []).filter(o => o.isActive)
            this.quotationTotalCount = typeof res.data.count === 'number' ? res.data.count : this.quotationOrders.length
          })
          .catch(e => {
            this.$store.state.snackbar = {
              text: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง ข้อความที่ระบบแจ้ง : ' + e.response.status + ' ' + e.response.statusText,
              visible: true,
              color: 'error'
            }
          })
          .finally(() => {
            this.quotationOrdersLoading = false
          })
    },
    loadProduct(params) {
      this.lastOrderSearchParams = params
      this.$store.state.isLoading = true
      axios.get('/api/orders/', {params: params})
          .then(res => {
            this.orders = res.data.data.filter(o => !(o.isActive === true && o.order_status === 'ใบเสนอราคา')) // NAND
          })
          .catch(e => {
            if (e.response.status === 401) {
              this.$router.push({path: '/login'})
            }
            this.$store.state.snackbar = {
              text: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง ข้อความที่ระบบแจ้ง : ' + e.response.status + ' ' + e.response.statusText,
              visible: true,
              color: 'error'
            }
          })
          .finally(() => {
            this.$store.state.isLoading = false
            this.fetchQuotationCount(params)
            this.quotationOrders = []
            if (this.quotationPanel === 0) {
              this.fetchQuotationPage({force: true, resetPage: true})
            }
          })
    },
    showProduct(item) {
      let string = ''
      item.forEach((i, index) => {
        if (i.name !== 'ค่าส่ง') {
          string += (`${i.name} ${i.quantity} ${i.unit}${index !== item.length - 1 ? ', ' : ''}`)
        }
      })
      return string
    },
    gotoPODetail(row) {
      let routeData = this.$router.resolve({path: `/order/${row.id}`});
      window.open(routeData.href, '_blank');
    },
    inRangeItem(range, items, column) {
      if (range.length === 1) {
        this.filteredPO = items.filter(item => DateTime.fromFormat(item[column], 'yyyy/LL/dd').toISODate() === DateTime.fromFormat(range[0], 'yyyy-LL-dd').toISODate())
      } else {
        range.sort()
        this.filteredPO = items.filter(item =>
            DateTime.fromFormat(item[column], 'yyyy/LL/dd').toISODate() >= DateTime.fromFormat(range[0], 'yyyy-LL-dd').toISODate()
            && DateTime.fromFormat(item[column], 'yyyy/LL/dd').toISODate() <= DateTime.fromFormat(range[1], 'yyyy-LL-dd').toISODate())
      }
    },
    customFilter(value, search, item) {
      search = this.search.toString().toLowerCase()
      return item[this.optionSearch].toString().includes(search)
    },
    colorStatus(status, isActive) {
      if (isActive) {
        switch (status) {
          case 'รับออเดอร์':
            return {text: status, color: 'primary'}
          case 'ใบเสนอราคา':
            return {text: status, color: 'orange'}
          case 'ดำเนินการ':
            return {text: status, color: 'amber'}
          case 'สำเร็จ':
            return {text: status, color: 'green'}
          case 'ชำระแล้ว':
            return {text: status, color: 'green'}
          case 'ยังไม่ชำระ':
            return {text: status, color: 'error'}
        }
      } else {
        if (status === 'ใบเสนอราคา') {
          return {text: 'ยกเลิกใบเสนอราคา', color: 'red'}
        } else {
          return {text: 'ยกเลิกออเดอร์', color: 'red'}
        }
      }
    },
    yearBeforeOrder(date) {
      return (parseInt(date.split('/')[0]) + 543) % 100
    }
    // formatDate(second) {
    //   return DateTime.fromSeconds(second).toFormat('dd/LL/yyyy')
    // },
  },
  computed: {
    dateRangeText() {
      if (this.dates === null) {
        return ""
      } else {
        // this.dates.sort()
        return this.dates.map((e) => DateTime.fromFormat(e, 'yyyy-LL-dd').toFormat('dd/LL/yyyy')).sort().join(' - ')
      }
    },
  },
}
</script>

<style scoped>
.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
  padding: 0 !important;
}

</style>
